import {
    RETRIEVE_CITIES,
    CREATE_CITY,
    UPDATE_CITY,
    UPDATE_CITY_STATUS,
    DELETE_CITY,
    RESTORE_CITY
  } from "../actions/types";
  
const initialState = { cities : [], totalCityCount : 0 };

const cityReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_CITIES:
      return {
        cities: payload.rows,
        totalCityCount: payload.count,
      };

    case CREATE_CITY:
      return payload;

    case UPDATE_CITY:
      return payload;

    case UPDATE_CITY_STATUS:
      return {
        cities: payload.rows,
        totalCityCount: payload.count,
      };

    case DELETE_CITY:
      return {
        cities: payload.rows,
        totalCityCount: payload.count,
      };

    case RESTORE_CITY:
      return {
        cities: payload.rows,
        totalCityCount: payload.count,
      };

    default:
      return state;
  }
};  

export default cityReducer;